/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getApplicationsList = (payload, callback) =>
  req.list(
    c.GET_APPLICATIONS_LIST,
    '/api/v1/rpt/administrator/buildings/building_applications',
    payload,
    callback
  );

export const showData = (id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
    payload,
    callback
  );

export const createApplication = (payload, callback) =>
  req.create(
    c.CREATE_APPLICATION,
    '/api/v1/rpt/administrator/buildings/building_applications/',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getLandApplicationsList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPLICATIONS_LIST,
    `/api/v1/rpt/administrator/land/land_applications/`,
    payload,
    callback
  );

export const getBuildingKindsList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_KINDS_LIST,
    `/api/v1/rpt/administrator/buildings/settings/building_kinds`,
    payload,
    callback
  );

export const getStructuralTypesList = (kindId, payload, callback) =>
  req.list(
    c.GET_STRUCTURAL_TYPES_LIST,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types`,
    payload,
    callback
  );

export const showStructuralType = (kindId, id, payload, callback) =>
  req.item(
    c.SHOW_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${kindId}/building_structural_types/${id}`,
    payload,
    callback
  );

export const getSingleBuildingOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_OWNER,
    `api/v1/rpt/administrator/buildings/building_owners/${id}`,
    payload,
    callback
  );

export const getSingleTransactCode = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_TRANSACT_CODE,
    `api/v1/rpt/administrator/settings/transaction_codes/${id}`,
    payload,
    callback
  );

export const getSingleLandApplication = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}`,
    payload,
    callback
  );

export const getSingleBuildingKind = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_KIND,
    `api/v1/rpt/administrator/buildings/settings/building_kinds/${id}`,
    payload,
    callback
  );

export const getSingleStructuralType = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_STRUCTURAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_structural_types/${id}`,
    payload,
    callback
  );

// building

export const getLandAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    callback
  );

export const getSingleLandAppraisal = (
  id,
  landAppraisalId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    callback
  );

export const createLandAppraisal = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    callback
  );

export const getSingleLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    callback
  );

export const createLandPropertyAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandMarketValueList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    callback
  );

export const getSingleLandMarketValue = (
  id,
  landMarketValueId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    callback
  );

export const createLandMarketValue = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandMarketValue = (
  id,
  landMarketValueId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandMarketValue = (
  id,
  landMarketValueId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    callback
  );

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    callback
  );

export const getOwnerList = (payload, callback) =>
  req.list(
    c.GET_OWNER_LIST,
    'api/v1/rpt/administrator/buildings/building_owners',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    callback
  );

export const findTdn = (payload, callback) =>
  req.create(
    c.FIND_TDN,
    '/api/v1/rpt/administrator/land/land_applications/search_tdn',
    payload,
    ({ res }) => {
      const data = res.res;
      if (callback) callback(data);
    }
  );

export const searchTdn = (tdn, code, payload, callback) =>
  req.item(
    c.SEARCH_TDN,
    `/api/v1/rpt/administrator/buildings/building_applications/validate_tdn?tdn=${tdn}&rptax_transaction_code_id=${code}&`,
    payload,
    callback
  );

export const getBuildingMaterialTypeList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_MATERIAL_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_material_types',
    payload,
    callback
  );

export const getSingleMaterialType = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_MATERIAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}`,
    payload,
    callback
  );

export const getSingleMaterial = (id, materialId, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_MATERIAL,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}/building_materials/${materialId}`,
    payload,
    callback
  );

export const getBuildingComponents = (payload, callback) =>
  req.list(
    c.GET_BUILDING_COMPONENTS,
    'api/v1/rpt/administrator/buildings/settings/building_components',
    payload,
    callback
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE_LIST,
    'api/v1/rpt/administrator/settings/actual_uses?status=1',
    payload,
    callback
  );

export const getSingleBuildingComponent = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_COMPONENT,
    `api/v1/rpt/administrator/buildings/settings/building_components/${id}`,
    payload,
    callback
  );

export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICTS_LIST,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );

export const getAppointedPersons = (payload, callback) =>
  req.list(
    c.GET_APPOINTED_PERSONS,
    'api/v1/rpt/administrator/land/settings/land_person_of_concern',
    payload,
    callback
  );

export const getLogs = (id, payload, callback) =>
  req.list(
    c.GET_LOGS,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/logs`,
    payload,
    callback
  );

export const cancelApplication = (id, payload, callback) =>
  req.create(
    c.CANCEL_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/cancel_posting`,
    payload,
    callback
  );

export const postApplication = (id, callback) =>
  req.create(
    c.POST_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/post`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const createTransferApplication = (payload, callback) =>
  req.create(
    c.CREATE_TRANSFER_APPLICATION,
    '/api/v1/rpt/administrator/buildings/building_applications/change',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTransferApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSFER_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/change/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBuildingApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_BUILDING_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getTdn = (payload, callback) =>
  req.item(
    c.GET_TDN,
    `/api/v1/rpt/administrator/land/tdn`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    },
    payload
  );

export const searchPin = (pin, code, payload, callback) =>
  req.item(
    c.SEARCH_PIN,
    `/api/v1/rpt/administrator/buildings/building_applications/validate_tdn?pin=${pin}&rptax_transaction_code_id=${code}&`,
    payload,
    callback
  );

export const getPaidTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_PAID_TRANSACTION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_transactions?is_paid=1`,
    payload,
    callback
  );

export const getPaymentHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_PAYMENT_HISTORY,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_transaction_payments`,
    payload,
    callback
  );

export const revertApplication = (id, callback) =>
  req.create(
    c.REVERT_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/revert`,
    {},
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Reverted!');
      if (callback) callback();
    }
  );

export const getTaxEffectivityPeriods = (id, payload, callback) =>
  req.list(
    c.GET_TAX_EFFECTIVITY_PERIOD,
    `api/v1/rpt/administrator/buildings/building_applications/${id}/tax_effectivity_periods`,
    payload,
    callback
  );

export const getLocationList = (payload, callback) =>
  req.list(
    c.GET_LOCATION_LIST,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    callback
  );

export const searchTdnConsolidation = (tdn, code, payload, callback) =>
  req.item(
    c.SEARCH_TDN_CONSOLIDATION,
    `/api/v1/rpt/administrator/buildings/building_applications/validate_tdn?tdn=${tdn}&rptax_transaction_code_id=${code}&`,
    payload,
    callback
  );

export const searchTdnSubdivision = (tdn, code, for_improvement, payload, callback) =>
  req.item(
    c.SEARCH_TDN_SUBDIVISION,
    `/api/v1/rpt/administrator/buildings/building_applications/validate_tdn?tdn=${tdn}&rptax_transaction_code_id=${code}&for_improvement=${for_improvement}&`,
    payload,
    callback
  );

  export const getEffectivityPeriod = (id, payload, callback) =>
    req.list(
      c.GET_EFFECTIVITY_PERIOD,
      `api/v1/rpt/administrator/buildings/building_applications/${id}/effectivity_periods`,
      payload,
      callback
    );
